import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-sky-50 py-8 px-4" data-testid="privacy-page">
    <div className="max-w-3xl mx-auto space-y-6">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-sky-600 hover:underline" data-testid="privacy-back-link">
        <ArrowLeft className="w-4 h-4" /> Torna alla home
      </Link>

      <Card>
        <CardContent className="py-8 prose prose-slate max-w-none">
          <h1 className="text-2xl font-bold text-slate-900 mb-6">Informativa sulla Privacy</h1>
          <p className="text-sm text-slate-500 mb-6">Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003</p>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">1. Titolare del Trattamento</h2>
          <p className="text-slate-600 mb-4">
            Il Titolare del trattamento dei dati personali e F.lli Schiliro' Servizi, con sede legale in Italia (di seguito "Titolare" o "Azienda").
          </p>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">2. Tipologia di Dati Raccolti</h2>
          <p className="text-slate-600 mb-2">Attraverso il form di quotazione raccogliamo i seguenti dati:</p>
          <ul className="list-disc list-inside text-slate-600 space-y-1 mb-4">
            <li><strong>Dati identificativi:</strong> nome, cognome, codice fiscale</li>
            <li><strong>Dati di contatto:</strong> numero di telefono, indirizzo email</li>
            <li><strong>Dati relativi alla fornitura energetica:</strong> consumi, codice POD/PDR, fornitore attuale, condizioni economiche presenti nella bolletta caricata</li>
            <li><strong>Indirizzo di fornitura:</strong> via, citta</li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">3. Finalita del Trattamento</h2>
          <p className="text-slate-600 mb-2">I dati personali sono trattati per le seguenti finalita:</p>
          <ul className="list-disc list-inside text-slate-600 space-y-1 mb-4">
            <li><strong>a) Erogazione del servizio:</strong> analisi della bolletta energetica, calcolo del risparmio stimato e confronto con le offerte disponibili sul mercato.</li>
            <li><strong>b) Contatto commerciale:</strong> se espressamente richiesto dall'utente, per essere ricontattato da un consulente energetico.</li>
            <li><strong>c) Gestione del rapporto:</strong> archiviazione della quotazione per futuri riferimenti e per migliorare il servizio.</li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">4. Base Giuridica del Trattamento</h2>
          <p className="text-slate-600 mb-4">
            Il trattamento dei dati si basa sul <strong>consenso espresso</strong> dell'interessato (Art. 6, par. 1, lett. a GDPR), prestato tramite la spunta dell'apposita casella nel form di quotazione, e sull'<strong>esecuzione di misure precontrattuali</strong> adottate su richiesta dell'interessato (Art. 6, par. 1, lett. b GDPR).
          </p>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">5. Modalita di Trattamento e Conservazione</h2>
          <p className="text-slate-600 mb-4">
            I dati sono trattati con strumenti elettronici, conservati su server sicuri e protetti da misure tecniche e organizzative adeguate. La bolletta caricata viene analizzata tramite sistemi di intelligenza artificiale per estrarre i dati di fornitura e viene eliminata immediatamente dopo l'analisi. I dati estratti vengono conservati per un periodo massimo di <strong>24 mesi</strong> dalla data della quotazione.
          </p>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">6. Comunicazione dei Dati</h2>
          <p className="text-slate-600 mb-4">
            I dati personali non vengono venduti a terzi. Possono essere condivisi esclusivamente con:
          </p>
          <ul className="list-disc list-inside text-slate-600 space-y-1 mb-4">
            <li>Consulenti energetici della nostra rete, esclusivamente per le finalita sopra indicate</li>
            <li>Fornitori di servizi tecnologici necessari al funzionamento della piattaforma (hosting, analisi AI), vincolati a clausole di riservatezza</li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">7. Diritti dell'Interessato</h2>
          <p className="text-slate-600 mb-2">In qualsiasi momento puoi esercitare i seguenti diritti:</p>
          <ul className="list-disc list-inside text-slate-600 space-y-1 mb-4">
            <li><strong>Accesso:</strong> ottenere conferma dell'esistenza dei tuoi dati e riceverne copia</li>
            <li><strong>Rettifica:</strong> richiedere la correzione di dati inesatti</li>
            <li><strong>Cancellazione:</strong> richiedere la cancellazione dei tuoi dati ("diritto all'oblio")</li>
            <li><strong>Portabilita:</strong> ricevere i dati in formato strutturato e leggibile</li>
            <li><strong>Opposizione:</strong> opporti al trattamento per motivi legittimi</li>
            <li><strong>Revoca del consenso:</strong> revocare il consenso in qualsiasi momento</li>
          </ul>
          <p className="text-slate-600 mb-4">
            Per esercitare i tuoi diritti, puoi contattarci all'indirizzo email indicato nella sezione contatti.
          </p>

          <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-3">8. Reclamo</h2>
          <p className="text-slate-600 mb-4">
            Hai il diritto di proporre reclamo all'Autorita Garante per la Protezione dei Dati Personali (www.garanteprivacy.it) se ritieni che il trattamento dei tuoi dati violi il GDPR.
          </p>

          <div className="mt-8 pt-6 border-t border-slate-200">
            <p className="text-sm text-slate-400">Ultimo aggiornamento: Marzo 2026</p>
            <p className="text-sm text-slate-400">F.lli Schiliro' Servizi - Luce & Gas</p>
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);

export default PrivacyPolicy;
